/** Remove this component */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Container, Stack, TextField, Typography } from '@mui/material';
import { theme } from '../../../constants/theme';
import { useThemeContext } from '../../../hook/useThemeManager';
import { Cancel } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import _, { isArray } from 'lodash';
import { IAdvancedContest, IProject, IUserSummary, UserSummary } from '../../../types/global/helper';
import { ShortSegmentedControl } from '../../SegmentedControl/ShortSegmentedControl';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { ThspianAvatar } from '../../Avatar/ThspianAvatar';
import { Spinner } from '@chakra-ui/react';
import { replaceRouteParam } from '../../../utils/routesProcessor';
import { navigate } from '../../../redux/navigator/action';
import { ROUTES } from '../../../types/global/routes.types';
import { AvatarShimmer } from '../EsMyProfileContainer/AvatarShimmer';
import {
    contestAwardCategoryAndAwardsSelector,
    fetchingSelector,
    jurySelector,
    loadingSelector,
    scoreBoardSelector,
    searchingUserSearchSelector,
    userSearchSelector,
} from '../../AvatarGroup/selector';
import CustomButton from '../../Button/CustomButton';
import { isEmpty } from '../../../utils/lodash';
import { getJurorForContest, getScoreBoard, inviteJury } from '../../../redux/jury/action';
import { IJuryDuties, ISubmission, TAudienceVote } from '../../../redux/jury/types';
import { MainTagCarousel } from '../../EsCarousels/MainTagCarousel';
import { getProject, setPlayerQuery } from '../../../redux/project/actions';
import { getIdForIbjects, getJWtDetails } from '../../../utils/AppUtils';
import { CustomizedSwitches } from '../../Switch/Switch';
import { PrizeAwardDialogue } from './PrizeAwardDialogue';
import { IAwardCategory } from '../../../redux/contest/types';
import { awardPrize } from '../../../redux/contest/actions';
import MailIcon from '../../CustomSVGIcons/MailIcon';
import { JudgeMessage } from './JudgeMessage';
import { StarRating } from '../../EsVideoVotingModal/EsRatingStars';

export interface IJuryDialogueModal {
    placeholder?: string;
    open: boolean;
    onClose?: () => void;
    contestId: string;
    contest?: IAdvancedContest;
}

/**
 *
 * @param param0
 * @returns
 *
 * I will attempt to handle the api call and redux operation for this module inside here
 * As I see that it only has one functionality, which is to search and select users.
 * In the future we will move it out of here to the parent to keep it uniform.
 */

const tabList = ['add jury', 'judges', 'score board'];
enum TABLIST {
    ADD_JURY = 'add jury',
    JUDGES = 'judges',
    SCORE_BOARD = 'score board',
}
enum TAG_LIST {
    JURY_SCORE = 'Jury Score',
    AUDIENCE_VOTE = 'Audience Vote',
}
const TAG = ['Jury Score', 'Audience Vote'];
type TabSelector = 'judges' | 'score board' | 'add jury';
const JuryDutyDialogue: React.FC<IJuryDialogueModal> = ({ placeholder, open, onClose, contestId, contest }) => {
    const [, setSearchValue] = useState('');
    const [visibleTab, setVisibleTab] = useState<TabSelector>(TABLIST.ADD_JURY);
    const { themeStyle } = useThemeContext();
    const { user } = getJWtDetails();
    const dispatch = useDispatch();
    const userResults = useSelector(userSearchSelector);
    const { audience_votes, jury_score } = useSelector(scoreBoardSelector) || {};
    const { contestAward, contestAwardCategory } = useSelector(contestAwardCategoryAndAwardsSelector);
    const judges = useSelector(jurySelector);
    const searchingUser = useSelector(searchingUserSearchSelector);
    const { fetchingScoreBoard } = useSelector(fetchingSelector);
    const sendingInvitation = useSelector(loadingSelector);
    const scrollRef = useRef<HTMLDivElement>(null);
    const [, setFilteredResult] = useState<IJuryDuties[]>([]);
    const [filteredAudienceVoteScore, setFilteredAudienceVoteScore] = useState<TAudienceVote[]>([]);
    const [filteredJuryScore, setFilteredJuryScore] = useState<ISubmission[]>([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedTag, setSelectedTag] = useState(TAG[0]);
    const [isAwardState, setIsAwardState] = useState(false);
    const [openAwardDialogue, setOpenAwardDialogue] = useState(false);
    const [selectedProjectForAward, setSelectedProjectForAward] = useState<IProject | undefined>(undefined);
    const [enableAssignAllSubmissionsToAllJudges, setEnableAssignAllSubmissionsToAllJudges] = useState(false);
    const [showJudgeMessage, setShowJudgeMessage] = useState(false);
    const [selectedSubmisison, setSelectedSubmsision] = useState<ISubmission>();
    const [, setCategories] = useState<string[]>([]);
    const [selectedCategory] = useState<string>('');

    useEffect(() => {
        if (contest && contest.categories) {
            setCategories(contest.categories);
        }
    }, [contest]);

    const handleAvatarClick = (avatar: IUserSummary) => {
        const profileRoute = replaceRouteParam(ROUTES.ESMY_PROFILE, 'profileId?', avatar.userName);
        dispatch(navigate({ routes: profileRoute }));
        onClose && onClose();
    };

    const handleSearchInputChange = (event: { target: { value: string } }) => {
        if (visibleTab === TABLIST.SCORE_BOARD) {
            if (selectedTag === TAG_LIST.AUDIENCE_VOTE) {
                const filtered = audience_votes.filter(
                    vote =>
                        vote?.project.created_by &&
                        (vote?.project.created_by.firstName.startsWith(event.target.value) ||
                            vote?.project.created_by.lastName.startsWith(event.target.value) ||
                            vote?.project.created_by.userName.startsWith(event.target.value)),
                );
                setFilteredAudienceVoteScore(filtered as TAudienceVote[]);
            }

            if (selectedTag === TAG_LIST.JURY_SCORE) {
                const filtered = jury_score.filter(
                    jury =>
                        jury?.project.created_by &&
                        (jury?.project.created_by.firstName.startsWith(event.target.value) ||
                            jury?.project.created_by.lastName.startsWith(event.target.value) ||
                            jury?.project.created_by.userName.startsWith(event.target.value)),
                );
                setFilteredJuryScore(filtered as ISubmission[]);
            }
        }
    };

    const handleGetJurors = useCallback(() => {
        dispatch(
            getJurorForContest({
                contestId: contestId,
                limit: 100,
                page: 1,
            }),
        );
    }, [dispatch, contestId]);

    const handlegetScoreBoard = useCallback(() => {
        dispatch(
            getScoreBoard({
                contestId: contestId,
                category: selectedCategory,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, contestId]);

    useEffect(() => {
        if (visibleTab === TABLIST.JUDGES) {
            setFilteredResult(judges);
        }
        if (visibleTab === TABLIST.SCORE_BOARD) {
            setFilteredAudienceVoteScore(audience_votes as TAudienceVote[]);
            setFilteredJuryScore(jury_score as ISubmission[]);
        }
    }, [visibleTab, audience_votes, jury_score, judges]);

    const handleChangeTab = (tab: string) => {
        setVisibleTab(tab as TabSelector);
        setSearchValue('');
        if (tab === TABLIST.SCORE_BOARD) {
            handlegetScoreBoard();
        }
        if (tab === TABLIST.JUDGES) {
            handleGetJurors();
        }
    };

    const handleInviteNewJury = (userId: string) => {
        setSelectedUser(userId);
        dispatch(
            inviteJury({
                contest: contestId,
                juries: [userId],
                bypass: true,
            }),
        );
        setSelectedUser('');
    };

    const shouldDisableButton = (userId: string) =>
        !!judges && !isEmpty(judges) && judges.some(judge => getIdForIbjects(judge.jury) === userId);

    const handleViewProject = (project: IProject) => {
        if (isAwardState) {
            // Create award here
            setSelectedProjectForAward(project);
            setOpenAwardDialogue(!openAwardDialogue);
        } else {
            dispatch(
                setPlayerQuery({
                    isSequential: false,
                    isSinglePreview: true,
                }),
            );
            dispatch(
                getProject({
                    id: project.video_id as string,
                    mediaType: 'video',
                    withNavigate: false,
                    skipAuthentication: true,
                    fromAnotherScreen: true,
                }),
            );
        }
    };

    const handeAssigningSubmissions = () => {};

    const handleSubmitAward = (prize?: IAwardCategory) => {
        const awardPayload: any = {
            award_category: prize?._id,
            award_project: selectedProjectForAward?._id,
            award_status: 'won', //TODO: Change thsi dynamially or from form
            award_year: new Date(),
            person_awarded: selectedProjectForAward?.created_by?._id,
            contest: contestId,
        };
        dispatch(awardPrize(awardPayload));
        setOpenAwardDialogue(!openAwardDialogue);
    };

    const hasUserBeenAwarded = (user?: UserSummary) => {
        return contestAward.some(awards => getIdForIbjects(awards.person_awarded) === getIdForIbjects(user));
    };

    const handleMessageClick = (submission?: ISubmission) => {
        if (submission) {
            setSelectedSubmsision(submission);
        } else {
            setSelectedSubmsision(undefined);
        }
        setShowJudgeMessage(!showJudgeMessage);
    };

    const shouldRenderMailIcon = (submission: ISubmission) => {
        if (!submission) return false;
        return (
            !!submission?.judge_note ||
            (!!submission.other_jury_scores &&
                isArray(submission.other_jury_scores) &&
                submission.other_jury_scores.some(score => !!score.judge_note))
        );
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            color="blue"
            PaperProps={{
                style: {
                    backgroundColor: theme[themeStyle].deep_grey_lighter,
                    overflowY: 'scroll',
                    border: '1px solid grey',
                    maxHeight: '100vh',
                    margin: 0,
                },
                sx: {
                    height: {
                        xs: '100vh',
                        sm: '70%',
                    },
                    width: {
                        xs: '100vw',
                        sm: '50%',
                        md: '40%',
                    },
                    borderRadius: {
                        xs: 3,
                        sm: 2,
                        md: 5,
                    },
                },
            }}>
            <ShortSegmentedControl
                tabs={tabList}
                onHandleClick={handleChangeTab}
                initialIndex={tabList.indexOf(visibleTab)}
                sx={{
                    width: '100%',
                }}
                tabStyle={{
                    width: '100%',
                }}
                buttonStyle={{
                    width: '100%',
                }}
            />
            <PrizeAwardDialogue
                prizes={
                    isEmpty(contestAward)
                        ? contestAwardCategory
                        : contestAwardCategory.filter(category =>
                              contestAward.every(awards => getIdForIbjects(awards.award_category) !== category._id),
                          )
                }
                onClose={() => setOpenAwardDialogue(!openAwardDialogue)}
                open={openAwardDialogue}
                onSubmit={handleSubmitAward}
            />
            {visibleTab === TABLIST.SCORE_BOARD && (
                <Container sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <MainTagCarousel
                        list={TAG}
                        disableViewAll
                        type="list"
                        onSelectTag={tag => {
                            setSelectedTag(tag);
                        }}
                    />
                </Container>
            )}
            {visibleTab === TABLIST.JUDGES && (
                <>
                    <Container sx={{ pt: 2, display: 'flex', alignItems: 'center' }}>
                        <CustomButton
                            onClick={() => handeAssigningSubmissions()}
                            customStyle={{
                                width: '100%',
                            }}
                            label={'Auto Assign Submissions'}
                            textStyle={{
                                fontSize: 12,
                            }}
                        />
                    </Container>
                    <Container sx={{ pt: 2, display: 'flex', alignItems: 'center' }}>
                        <CustomizedSwitches
                            label="Assign All Submissions"
                            style={{
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                color: theme[themeStyle].tag_white,
                            }}
                            labelPlacement="start"
                            switchProps={{
                                color: 'primary',
                                centerRipple: true,
                                value: enableAssignAllSubmissionsToAllJudges,
                                onChange: () =>
                                    setEnableAssignAllSubmissionsToAllJudges(!enableAssignAllSubmissionsToAllJudges),
                            }}
                        />
                    </Container>
                </>
            )}
            <TextField
                autoFocus
                variant="outlined"
                placeholder={placeholder ?? 'Search users...'}
                color="secondary"
                InputProps={{
                    placeholder: placeholder ?? `Search ${visibleTab}...`,
                    style: {
                        color: theme[themeStyle].tag_white, // Change the placeholder color to white
                        border: '0.5px solid white', // Set the border width and color
                        borderRadius: '50px', // Set the border radius
                        paddingLeft: '8px', // Add some padding for the text inside the input field
                        fontSize: 12,
                        minWidth: 200,
                    },
                }}
                inputProps={{
                    color: 'blue',
                }}
                // Add your search functionality here
                onChange={e => {
                    handleSearchInputChange(e);
                }}
                sx={{
                    px: 3,
                    pt: 3,
                    pb: 1,
                }}
            />
            {visibleTab === TABLIST.SCORE_BOARD && (
                <Container sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
                    <CustomizedSwitches
                        label="Award"
                        labelPlacement="start"
                        style={{
                            color: theme[themeStyle].tag_white,
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        }}
                        switchProps={{
                            color: 'primary',
                            centerRipple: true,
                            value: isAwardState,
                            onChange: () => setIsAwardState(!isAwardState),
                        }}
                    />
                </Container>
            )}
            <DialogContent ref={scrollRef}>
                {visibleTab === TABLIST.ADD_JURY && (
                    <>
                        {searchingUser && new Array(20).fill('X').map((_, i) => <AvatarShimmer key={i} />)}
                        {!!userResults &&
                            !searchingUser &&
                            !_.isEmpty(userResults) &&
                            userResults.map((user, index) => (
                                <Stack
                                    flexDirection="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    key={index}
                                    mb={1}>
                                    <Stack flexDirection="row" alignItems="center">
                                        <ThspianAvatar
                                            key={index}
                                            user={user as unknown as IUserSummary}
                                            onClick={() => handleAvatarClick(user as unknown as IUserSummary)}
                                            sx={{
                                                cursor: 'pointer',
                                                borderRadius: '50%',
                                                marginRight: '10px',
                                                height: 60,
                                                width: 60,
                                            }}
                                        />
                                        <Stack direction="column">
                                            <Typography
                                                style={{
                                                    color: theme[themeStyle].tag_white,
                                                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                    fontSize: 14,
                                                }}>
                                                {user.firstName} {user.lastName}
                                            </Typography>
                                            <Typography
                                                style={{
                                                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                    fontSize: 10,
                                                    color: theme[themeStyle].tag_white,
                                                }}>
                                                @{user.userName}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                    <CustomButton
                                        onClick={() => handleInviteNewJury(user._id)}
                                        disabled={shouldDisableButton(user._id)}
                                        customStyle={{
                                            width: '100px',
                                        }}
                                        loading={selectedUser === user._id && sendingInvitation}
                                        label={shouldDisableButton(user._id) ? 'Invited' : 'Invite'}
                                        textStyle={{
                                            fontSize: 12,
                                        }}
                                    />
                                </Stack>
                            ))}
                    </>
                )}

                {visibleTab === TABLIST.SCORE_BOARD && (
                    <>
                        {fetchingScoreBoard && new Array(20).fill('X').map((_, i) => <AvatarShimmer key={i} />)}
                        {selectedTag === TAG_LIST.JURY_SCORE &&
                            !!filteredJuryScore &&
                            !fetchingScoreBoard &&
                            !_.isEmpty(filteredJuryScore) &&
                            filteredJuryScore.map((sub, index) => {
                                const {
                                    project: { created_by, feature_image, title },
                                } = sub;
                                const isHost = user?._id === created_by?._id;
                                return (
                                    <Stack
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        key={index}
                                        mb={1}>
                                        <Stack flexDirection="row" alignItems="center" position="relative">
                                            {sub.total_average && (
                                                <Typography
                                                    sx={{
                                                        position: 'absolute',
                                                        left: -2,
                                                        top: -2,
                                                        backgroundColor: theme[themeStyle].true_black,
                                                        border: `1px solid ${theme[themeStyle].deep_grey_lighter}`,
                                                        p: 1,
                                                        fontFamily: FONT_ENUM.REGULAR_HEADER,
                                                        color: theme[themeStyle].true_white,
                                                        fontSize: 8,
                                                        borderRadius: 4,
                                                        zIndex: 999,
                                                    }}>
                                                    {sub.total_average.toFixed(2)}
                                                </Typography>
                                            )}
                                            <ThspianAvatar
                                                key={index}
                                                user={
                                                    isHost
                                                        ? {
                                                              firstName: title,
                                                              lastName: title,
                                                              feature_image: feature_image,
                                                              role: '',
                                                              userName: title,
                                                              audme_profile: '',
                                                              _id: created_by?._id!,
                                                              profile_picture: feature_image,
                                                              id: '',
                                                          }
                                                        : (created_by as unknown as IUserSummary)
                                                }
                                                onClick={() => handleAvatarClick(created_by as unknown as IUserSummary)}
                                                sx={{
                                                    cursor: 'pointer',
                                                    borderRadius: '50%',
                                                    marginRight: '10px',
                                                    height: 60,
                                                    width: 60,
                                                }}
                                            />
                                            {!!selectedSubmisison && (
                                                <JudgeMessage
                                                    submissions={selectedSubmisison}
                                                    onClose={handleMessageClick}
                                                    open={showJudgeMessage}
                                                />
                                            )}
                                            {!!created_by && (
                                                <Stack direction="column">
                                                    {isHost ? (
                                                        <Typography
                                                            style={{
                                                                color: theme[themeStyle].tag_white,
                                                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                                fontSize: 14,
                                                            }}>
                                                            {title}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            style={{
                                                                color: theme[themeStyle].tag_white,
                                                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                                fontSize: 14,
                                                            }}>
                                                            {created_by.firstName} {created_by.lastName}
                                                        </Typography>
                                                    )}
                                                    <Stack flexDirection="row" alignItems="center" gap={'5px'}>
                                                        <Typography
                                                            style={{
                                                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                                fontSize: 10,
                                                                color: theme[themeStyle].tag_white,
                                                            }}>
                                                            @{created_by.userName}
                                                        </Typography>
                                                        {shouldRenderMailIcon(sub) && (
                                                            <MailIcon
                                                                onClick={() => handleMessageClick(sub)}
                                                                stroke={theme[themeStyle].tag_white}
                                                                style={{
                                                                    height: 20,
                                                                    width: 20,
                                                                }}
                                                            />
                                                        )}
                                                    </Stack>
                                                </Stack>
                                            )}
                                        </Stack>
                                        <Stack
                                            flexDirection={{
                                                xs: 'column',
                                                sm: 'row',
                                            }}
                                            alignItems="center"
                                            gap={'10px'}>
                                            <StarRating
                                                style={{
                                                    width: 'fit-content',
                                                }}
                                                disabled
                                                ratingProps={{
                                                    value: sub.total_average ?? sub.jury_score?.total ?? 0,
                                                    readOnly: true,
                                                }}
                                            />

                                            <CustomButton
                                                onClick={() => handleViewProject(sub.project)}
                                                disabled={isAwardState && hasUserBeenAwarded(created_by)}
                                                customStyle={{
                                                    width: '100px',
                                                }}
                                                label={
                                                    isAwardState
                                                        ? hasUserBeenAwarded(created_by)
                                                            ? 'Awarded'
                                                            : 'Award'
                                                        : 'View Project'
                                                }
                                                textStyle={{
                                                    fontSize: 12,
                                                }}
                                            />
                                        </Stack>
                                    </Stack>
                                );
                            })}
                        {selectedTag === TAG_LIST.AUDIENCE_VOTE &&
                            !!filteredAudienceVoteScore &&
                            !fetchingScoreBoard &&
                            !_.isEmpty(filteredAudienceVoteScore) &&
                            filteredAudienceVoteScore.map((sub, index) => {
                                const {
                                    project: { created_by, feature_image, title },
                                } = sub;
                                const isHost = user?._id === created_by?._id;
                                return (
                                    <Stack
                                        flexDirection="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        key={index}
                                        mb={1}>
                                        <Stack flexDirection="row" alignItems="center">
                                            <ThspianAvatar
                                                key={index}
                                                user={
                                                    isHost
                                                        ? {
                                                              firstName: title,
                                                              lastName: title,
                                                              feature_image: feature_image,
                                                              role: '',
                                                              userName: title,
                                                              audme_profile: '',
                                                              _id: created_by?._id!,
                                                              profile_picture: feature_image,
                                                              id: '',
                                                          }
                                                        : (created_by as unknown as IUserSummary)
                                                }
                                                onClick={() => handleAvatarClick(created_by as unknown as IUserSummary)}
                                                sx={{
                                                    cursor: 'pointer',
                                                    borderRadius: '50%',
                                                    marginRight: '10px',
                                                    height: 60,
                                                    width: 60,
                                                }}
                                            />
                                            {!!created_by && (
                                                <Stack direction="column">
                                                    {isHost ? (
                                                        <Typography
                                                            style={{
                                                                color: theme[themeStyle].tag_white,
                                                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                                fontSize: 14,
                                                            }}>
                                                            {title}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            style={{
                                                                color: theme[themeStyle].tag_white,
                                                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                                fontSize: 14,
                                                            }}>
                                                            {created_by.firstName} {created_by.lastName}
                                                        </Typography>
                                                    )}
                                                    <Stack flexDirection="row" alignItems="center" gap={'5px'}>
                                                        <Typography
                                                            style={{
                                                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                                                fontSize: 10,
                                                                color: theme[themeStyle].tag_white,
                                                            }}>
                                                            @{created_by.userName}
                                                        </Typography>
                                                        {shouldRenderMailIcon(sub) && (
                                                            <MailIcon
                                                                onClick={() => handleMessageClick(sub)}
                                                                stroke={theme[themeStyle].tag_white}
                                                                style={{
                                                                    height: 20,
                                                                    width: 20,
                                                                }}
                                                            />
                                                        )}
                                                    </Stack>
                                                </Stack>
                                            )}
                                        </Stack>
                                        <Stack flexDirection="row" alignItems="center" gap={'10px'}>
                                            <Typography
                                                style={{
                                                    fontSize: 12,
                                                    color: theme[themeStyle].tag_white,
                                                    fontFamily: FONT_ENUM.REGULAR_HEADER,
                                                }}>
                                                {sub.total_votes} Votes
                                            </Typography>
                                            <CustomButton
                                                onClick={() => handleViewProject(sub.project)}
                                                disabled={isAwardState && hasUserBeenAwarded(created_by)}
                                                customStyle={{
                                                    width: '100px',
                                                }}
                                                label={
                                                    isAwardState
                                                        ? hasUserBeenAwarded(created_by)
                                                            ? 'Awarded'
                                                            : 'Award'
                                                        : 'View Project'
                                                }
                                                textStyle={{
                                                    fontSize: 12,
                                                }}
                                            />
                                        </Stack>
                                    </Stack>
                                );
                            })}
                    </>
                )}
            </DialogContent>

            {false && <Spinner pos="absolute" color="white" size="xl" right={'50%'} bottom={10} h={5} w={5} />}

            <DialogActions sx={{ position: 'absolute', right: 10, bottom: 10 }}>
                <IconButton
                    color="primary"
                    aria-label="Add Avatar"
                    onClick={onClose}
                    style={{
                        borderRadius: '50%',
                        borderWidth: 1,
                        borderColor: theme[themeStyle].lightWhite,
                        width: 30,
                    }}>
                    <Cancel sx={{ color: theme[themeStyle].true_white }} />
                </IconButton>
            </DialogActions>
        </Dialog>
    );
};

export { JuryDutyDialogue };
